import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Stack,
  MenuItem,
  Autocomplete,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

import { collection, getDocs, query } from "firebase/firestore";
import { db } from "../Config/firebase";
import { consultaTenantAtual } from "../Utils/tenant";
import "./GerarEtiquetas.css";
import Navbar from "../Components/Navbar/navbar";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";

export default function GerarEtiquetas() {
  const [obras, setObras] = useState([]);
  const [obraSelecionada, setObraSelecionada] = useState(null);
  const [data, setData] = useState("");
  const [codigoInicial, setCodigoInicial] = useState(1);
  const [quantidadeCodigos, setQuantidadeCodigos] = useState(5);
  const [quantidadePorCodigo, setQuantidadePorCodigo] = useState(4);
  const [etiquetaBranca, setEtiquetaBranca] = useState(false);




  useEffect(() => {
    async function carregar() {
      const snapshot = await getDocs(
        consultaTenantAtual(query(collection(db, "obras")))
      );

      const lista = snapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .filter((o) => o.ativo);

      setObras(lista);
    }

    carregar();
  }, []);

  const etiquetas = [];

  for (let i = 0; i < quantidadeCodigos; i++) {
    const codigo = codigoInicial + i;
    for (let j = 0; j < quantidadePorCodigo; j++) {
      etiquetas.push(codigo);
    }
  }

  const paginasEtiquetas = [];
  for (let i = 0; i < etiquetas.length; i += 20) {
    paginasEtiquetas.push(etiquetas.slice(i, i + 20));
  }
  

  return (
  <div className="relatorio-etiquetas">
    {/* NAVBAR - NÃO IMPRIME */}
    <Box className="no-print">
      <Navbar />
    </Box>

    <Box className="etiquetas-container" sx={{ p: 4, pt: "88px" }}>

      {/* BLOCO QUE NÃO DEVE IMPRIMIR */}
      <Box className="no-print">
        <Typography variant="h5" mb={3}>
          Gerar Etiquetas
        </Typography>

        <Paper sx={{ p: 3, mb: 4 }}>
          <Stack spacing={2} direction="row">

            <Autocomplete
              options={obras}
              getOptionLabel={(option) => option.nome || ""}
              value={obraSelecionada}
              onChange={(event, newValue) => {
                setObraSelecionada(newValue);
              }}
              renderInput={(params) => (
                <TextField {...params} label="Obra" />
              )}
              sx={{ minWidth: 350 }}
            />

            <TextField
              type="date"
              label="Data"
              InputLabelProps={{ shrink: true }}
              value={data}
              onChange={(e) => setData(e.target.value)}
            />

            <TextField
              type="number"
              label="Código inicial"
              value={codigoInicial}
              onChange={(e) =>
                setCodigoInicial(Number(e.target.value))
              }
              sx={{ width: 140 }}
            />

            <TextField
              type="number"
              label="Quantidade de códigos"
              value={quantidadeCodigos}
              onChange={(e) =>
                setQuantidadeCodigos(Number(e.target.value))
              }
              sx={{ width: 160 }}
            />

            <TextField
              type="number"
              label="Etiquetas por código"
              value={quantidadePorCodigo}
              onChange={(e) =>
                setQuantidadePorCodigo(Number(e.target.value))
              }
              sx={{ width: 180 }}
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={etiquetaBranca}
                  onChange={(e) =>
                    setEtiquetaBranca(e.target.checked)
                  }
                />
              }
              label="Imprimir etiquetas em branco"
            />

           <Button
  variant="contained"
  onClick={() => {
    const conteudo = document.querySelector(".etiqueta-print");

    if (!conteudo) return;

    const janela = window.open("", "_blank", "width=1200,height=800");

    janela.document.write(`
      <html>
        <head>
          <title>Etiquetas</title>

          <style>
            @page {
              size: A4 landscape;
              margin: 0;
            }

            html,
            body {
              margin: 0;
              padding: 0;
              background: #fff;
            }

            * {
              box-sizing: border-box;
            }

            .etiqueta {
              border: 1px solid #000;
              font-family: Arial, sans-serif;
              display: flex;
              flex-direction: column;
              height: 100%;
              min-height: 0;
              overflow: hidden;
              box-sizing: border-box;
              break-inside: avoid;
              page-break-inside: avoid;
            }

            .linha {
              display: grid;
              grid-template-columns: 22% 1fr 15%;
              border-bottom: 1px solid #000;
              align-items: stretch;
              min-height: 7mm;
            }

            .linha:last-child {
              border-bottom: none;
            }

            .logo-linha {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 14mm;
              border-bottom: 1px solid #000;
              padding: 0.4mm;
              box-sizing: border-box;
            }

            .etiqueta .logo-etiqueta {
              display: block;
              max-height: 10.8mm;
              max-width: 96%;
              width: auto;
              object-fit: contain;
            }

            .col-label {
              border-right: 1px solid #000;
              text-align: center;
              font-weight: bold;
              font-size: 13px;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .col-centro {
              border-right: 1px solid #000;
              text-align: center;
              font-size: 16px;
              display: flex;
              justify-content: center;
              align-items: center;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .col-direita {
              text-align: center;
              font-weight: bold;
              font-size: 13px;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .codigo {
              font-size: 24px;
              font-weight: bold;
            }

            .data-texto {
              font-size: 20px;
              font-weight: bold;
            }

            .etiqueta-print {
              width: 297mm;
              margin: 0;
              padding: 0;
            }

            .etiqueta-pagina {
              width: 297mm;
              height: 206mm;
              margin: 0;
              padding: 4.5mm 4mm 0.5mm;
              box-sizing: border-box;
              overflow: hidden;
              break-after: page;
              page-break-after: always;
            }

            .etiqueta-pagina:last-child {
              page-break-after: auto;
              break-after: auto;
            }

            .etiqueta-pagina .print-area {
              width: 100%;
              height: 100%;
              display: grid;
              grid-template-columns: repeat(4, 1fr);
              grid-template-rows: repeat(5, minmax(0, 1fr));
              grid-auto-flow: row;
              gap: 1mm;
              box-sizing: border-box;
              overflow: hidden;
            }

            .etiqueta-pagina .etiqueta {
              width: 100%;
              height: 100%;
              break-inside: avoid;
              page-break-inside: avoid;
            }

            .etiqueta-pagina .logo-linha {
              flex: 0 0 12mm;
              height: 12mm;
              min-height: 0;
            }

            .etiqueta-pagina .linha:not(.logo-linha) {
              flex: 1 1 0;
              min-height: 0;
            }

            @media print {
              .etiqueta-print {
                margin: 0;
              }

              .etiqueta-pagina {
                break-after: page;
                page-break-after: always;
              }

              .etiqueta-pagina:last-child {
                break-after: auto;
                page-break-after: auto;
              }
            }
          </style>
        </head>

        <body>
          ${conteudo.outerHTML}

          <script>
            window.onload = async function () {
              const imagens = Array.from(document.images);
              await Promise.all(imagens.map(function (imagem) {
                if (imagem.complete) return Promise.resolve();
                return new Promise(function (resolve) {
                  imagem.onload = resolve;
                  imagem.onerror = resolve;
                });
              }));
              window.focus();
              window.print();
              window.close();
            };
          </script>
        </body>
      </html>
    `);

    janela.document.close();
  }}
>
  Imprimir
</Button>

          </Stack>
        </Paper>
      </Box>

      {/* ÁREA DE IMPRESSÃO */}
{(obraSelecionada || etiquetaBranca) && (
  <div className="etiqueta-print">
    {paginasEtiquetas.map((paginaEtiquetas, paginaIndex) => (
      <div className="etiqueta-pagina" key={`pagina-etiqueta-${paginaIndex}`}>
        <div className="print-area">
          {paginaEtiquetas.map((codigo, index) => (
            <Etiqueta
              key={`${paginaIndex}-${index}`}
              obra={obraSelecionada}
              data={data}
              codigo={codigo}
              etiquetaBranca={etiquetaBranca}
            />
          ))}
        </div>
      </div>
    ))}
  </div>
)}

    </Box>
  </div>
);
}


/* COMPONENTE ETIQUETA */
function Etiqueta({ obra, data, codigo, etiquetaBranca }) {

  const dia = data ? data.split("-")[2] : "";
  const mes = data ? data.split("-")[1] : "";

  return (
    <div className="etiqueta">

     <div className="linha logo-linha">
  <LogoRelatorio
    alt="Logo"
    className="logo-etiqueta"
    style={{ maxHeight: "10.8mm", maxWidth: "96%", width: "auto", height: "auto" }}
   />
</div>


      <div className="linha">
        <div className="col-label">EMP:</div>
        <div className="col-centro">
          <span style={{ visibility: etiquetaBranca ? "hidden" : "visible" }}>
            {obra && (obra.clienteEtiqueta || "-")}
          </span>
        </div>
        <div className="col-direita">DATA</div>
      </div>

      <div className="linha">
        <div className="col-label">OBRA:</div>
        <div className="col-centro">
          <span style={{ visibility: etiquetaBranca ? "hidden" : "visible" }}>
            {obra && (obra.nomeEtiqueta || obra.nome)}
          </span>
        </div>
        <div className="col-direita data-texto">
          <span style={{ visibility: etiquetaBranca ? "hidden" : "visible" }}>
            {dia}
          </span>
        </div>
      </div>

      <div className="linha">
        <div className="col-label">CÓD:</div>
        <div className="col-centro codigo">
          <span style={{ visibility: etiquetaBranca ? "hidden" : "visible" }}>
            {codigo}
          </span>
        </div>
        <div className="col-direita data-texto">
          <span style={{ visibility: etiquetaBranca ? "hidden" : "visible" }}>
            {mes}
          </span>
        </div>
      </div>

    </div>
  );
}
